export default {
    CURRENCY: 'USD',
    STATUSES: {
        PENDING: 'PENDING',
        APPROVED: 'APPROVED',
        REVERSED: 'REVERSED',
    },
};
